import { defineStore } from "pinia"
import axios from 'axios'

// restore the uniqueId from localStorage or generate a new one and store it
const getUniqueId = () => {
    const key = "wq-unique-id"
    let uniqueId = localStorage.getItem(key);
    if (!uniqueId) {
        uniqueId = generateUniqueId()
        localStorage.setItem(key, uniqueId)
    }

    return uniqueId
}

// quick way to generate a Unique ID
const generateUniqueId = () => {
    const timestamp = new Date().getTime()
    const randomNumbers = Math.random().toString(36).substr(2, 9)
    return `${timestamp}-${randomNumbers}`
}

export const useUiElements = defineStore("deviceStorage", {
    state: () =>  {
        console.log("state initialized")
        let myauth = null
        if (process.env.VUE_APP_WURFLQUERY_BE_USER && process.env.VUE_APP_WURFLQUERY_BE_APIKEY) {
            console.log("process.env.VUE_APP_WURFLQUERY_BE_USER : " + process.env.VUE_APP_WURFLQUERY_BE_USER)
            myauth = {
                username: process.env.VUE_APP_WURFLQUERY_BE_USER || '',
                password: process.env.VUE_APP_WURFLQUERY_BE_APIKEY || ''
              }
        }
        return {

            uniqueId: getUniqueId(),
            baseRestApiUrl: process.env.VUE_APP_WURFLQUERY_URL || 'http://localhost:5000',
            baseRestApiAuth: myauth,
            deviceList: [], // result  of query
            selectedDevice: null, //currently selected device
            availableCapabilities: [],  // capabilities supported by the backend

            activeModalAlertMsg: '', // Needed to trigger Model dialog box
            showModal: false,
            variant: "danger",
            errors: [], // give some feedback about HTTP errors
            pusher_key: process.env.VUE_APP_PUSHER_KEY || "",
            pusher_cluster: process.env.VUE_APP_PUSHER_CLUSTER || ""
        }
    },

    getters: {

        getCurrentDevice: (state) => {
            return state.selectedDevice;
        },

        getCurrentDeviceCompleteName: (state) => {
            if (!state.selectedDevice) {
                return ""
            }
            let completeName = state.selectedDevice.capabilities.brand_name + " " + state.selectedDevice.capabilities.model_name
            if (state.selectedDevice.capabilities.marketing_name) {
                completeName += " (" + state.selectedDevice.capabilities.marketing_name+")"
            }
            return completeName
        },

        realBaseUrl: (state) => {

            if (!state.baseRestApiUrl) {
                return window.location.protocol +"//"+ window.location.host
            }
            return state.baseRestApiUrl
        }
    },

    actions: {

        setCurrentDevice(wid) {
            console.log("setCurrentDevice clicked : " + wid);
            // this.selectedDevice = wid;
            this.selectedDevice = this.deviceList.find(dev => wid === dev.wurfl_id);

        },

        setCurrentDeviceObject(item) {
            console.dir("setCurrentDeviceObject clicked : ", item);
            // this.selectedDevice = item;
            this.selectedDevice = item

        },

        setCurrentDeviceThroughREST(wid) {
            console.log("setCurrentDeviceThroughREST clicked : " + wid);
            // console.log("this.realBaseUrl: ", this.realBaseUrl)
            axios({
                method: 'get',
                url: `${this.realBaseUrl}/v1/devices/${wid}`,
                auth: this.baseRestApiAuth
              })
              .then(resp => {
                // console.log(resp.data)
                // this.selectedDevice = JSON.parse(JSON.stringify(resp.data)) // resp.data
                // this.selectedDevice = { ...this.selectedDevice, ...resp.data };
                this.selectedDevice = resp.data
                this.retrieveStatus = ''
              })
              .catch(err => {
                // error. To be honest we could improve usability by making the error message a modal.
                console.log("Logging server ERROR: " + err + " - " + err.response.data)
                // refactor to show diagnostics
                // this.retrieveStatus = '';
                this.errors = []
                this.errors.push(err)
                this.errors.push(err.response.data)
              })
        },

        setCurrentDeviceList(mylist) {
            console.log("setCurrentDevice List : ")
            this.deviceList = mylist
        },


        setAvailableCapabilities(mylist) {
            console.log("setAvailableCapabilitiSes List : ")
            this.availableCapabilities = mylist
        },


        setModalAlert(msg) {
            console.log("set Modal dialog to : "+msg)
            this.activeModalAlertMsg = msg
            this.showModal = true
        },

        resetModalAlert() {
            console.log("resetting modal...")
            this.activeModalAlertMsg = ""
            this.showModal = false
        },

        setHTTPErrorMessage(item) {
            this.errors = []
            this.errors.push(item)
        //     console.log(this.errors.length)
        //     while (this.errors.length > 4) {
        //         console.log(this.errors.length)
        //         this.errors.shift()
        //         console.log(this.errors.length)
        //     }
        //
        },

        resetHTTPErrors() {
            this.errors = []
        },

        resetStore() {
          // Reset the state to its initial values
          Object.assign(this, this.$reset())
        },
    }
});
